<template>
    <Breadcrumbs :title="pageTitle" :modal="'createNew'" />
    <div class="container-fluid">
        <div class="row starter-main">
            <zeroConfiguration :tableObj="data" :title="title" @edit="handleEdit" @delete="handleDelete" @view="handleView" />
        </div>
    </div>

    <div class="modal fade"  id="createNew" :class="{ 'show': isModalOpen }" tabindex="-1" ref="modal" role="dialog" aria-labelledby="tooltipmodal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Create {{pageTitle}}</h5>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="col-12">
                <label class="form-label" for="validationCustom04">State</label>
                <select class="form-select" id="validationCustom04"
                    v-model="addObj.processId" required>
                    <option selected disabled value="">Choose Process</option>
                    <option v-for="(value, index) in processTypes.data" :value="value" :key="index">{{
                        title
                    }}
                    </option>
                </select>    
            </div>
                    <div class="col-12">
                <label class="form-label" for="validationCustom01">Title</label>
                <input type="text" class="form-control"
                    id="name" placeholder="Title" v-model="addObj.title">

            </div>
                   
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                    <button class="btn btn-primary" type="button" @click="saveData">Save changes</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade"  ref="modal" id="editModal" tabindex="-1" role="dialog" aria-labelledby="tooltipmodal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Edit {{pageTitle}}</h3>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" @click="closeEditModal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="col-12">
                <label class="form-label" for="validationCustom04">Process</label>
                <select class="form-select" id="validationCustom04"
                    v-model="rowData.processId" required>
                    <option selected disabled value="">Choose Process</option>
                    <option v-for="(value, index) in processTypes.data" :value="value" :key="index">{{
                        title
                    }}
                    </option>
                </select>    
            </div>
                    <div class="col-12">
                    <label class="form-label" for="validationCustom01">Title</label>
                    <input type="text" class="form-control"
                        id="name" placeholder="Title" v-model="rowData.title">

                </div>
                   
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" @click="closeEditModal" data-bs-dismiss="modal">Close</button>
                    <button class="btn btn-primary" type="button" @click="updateData">Save changes</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import { ref,defineAsyncComponent, onMounted,reactive } from 'vue'
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import table from "@/core/data/teams.json"
import processTypes from "@/core/data/processType.json"

const title = ref('Teams List')
const data = ref([]);
const zeroConfiguration = defineAsyncComponent(() => import("@/components/commen/table/zeroConfiguration.vue"))

const pageTitle = "Teams"
const addObj = ref({
    "id": 1,
    "title": "",
    "processId": "",
    "processTitle": ""
})
const rowData = ref({})
const modal = ref(null);
const isModalOpen = ref(false);
function handleEdit(row) {
      // Handle edit event from child component
      console.log('Edit row:', row);
      rowData.value = { ...row}
      console.log(isModalOpen.value);
      showModalById('editModal').show();
      console.log(isModalOpen.value);
      // Implement your edit logic here
    }
    function handleView(row) {
      // Handle edit event from child component
      console.log('Edit row:', row);
      rowData.value = { ...row}
      console.log(isModalOpen.value);
      showModalById('editModal').show();
      console.log(isModalOpen.value);
      // Implement your edit logic here
    }
function closeModal() {
    isModalOpen.value = true;
    setTimeout(() => {
        location.reload();
    }, 1000);
}

function handleDelete(id) {
    const index = data.value.data.findIndex(item => item.id === id);

if (index !== -1) {
    // Remove the object from the data array
    data.value.data.splice(index, 1);
    success_with_icon("Record updated successfully");
    } else {
        error_with_icon("Record didn't found");
    }
    }
function saveData()
{
    const lastId = data.value.data[data.value.data.length - 1].id;
    const newId = lastId + 1;
    addObj.value.id = newId;
    const selectedProcess = processTypes.data.find(process => process.id === addObj.value.processId);
    addObj.value.processTitle = selectedProcess ? selectedProcess.title : '';
    data.value.data.push(addObj);
    success_with_icon("Record added successfully")
    closeModal();
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        backdrop.remove();
    }
}
function updateData()
{
    const updatedId = rowData.value.id;
    const updatedTitle = rowData.value.title;
    const rowIndex = data.value.data.findIndex(row => row.id === updatedId);

    if (rowIndex !== -1) {
        // Retrieve the process object based on the selected processId
        const selectedProcess = processTypes.data.find(process => process.id === rowData.value.processId);

        // Update the title, processId, and processTitle
        data.value.data[rowIndex].title = updatedTitle;
        data.value.data[rowIndex].processId = rowData.value.processId;
        data.value.data[rowIndex].processTitle = selectedProcess ? selectedProcess.title : '';

        success_with_icon("Record updated successfully");
    } else {
        error_with_icon("Record didn't found");
    }
    closeModal();
   
}
function deleteData()
{
    success_with_icon("Record deleted successfully")
}

function success_with_icon(message) {
    toast.success(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function info_with_icon(message) {
    toast.info(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function error_with_icon(message) {
    toast.error(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function info_with_cancle(message) {
    toast.info(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function closeEditModal()
{
    hideModalById('editModal').hide();
}
const hideModalById = (modalId) => {
  const hide = () => {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove("show");
      modal.style.display = "none";
    }
  };

  return { hide };
};

const showModalById = (modalId) => {
  const show = () => {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add("show");
      modal.style.display = "block";
    }
  };

  return { show };
};
onMounted(() => {
  data.value = JSON.parse(JSON.stringify(table));
});
</script>